import { useDispatch } from 'react-redux';

import { setFeatureFlags } from 'store/actions/featureFlag';

function useFeatureFlag() {
  const dispatch = useDispatch();

  function fetchFeatureFlags(auth) {
    dispatch(setFeatureFlags(auth));
  }

  return { fetchFeatureFlags };
}

export default useFeatureFlag;
